export const redirectToLogin = (tab?: string) => {
  const url = new URL("/auth", window.location.origin);
  if (tab) {
    url.searchParams.set("tab", tab);
  }
  url.searchParams.set(
    "redirect",
    encodeURIComponent(`${window.location.pathname}${window.location.search}`)
  );
  window.location.href = url.href;
};
